import { Tag } from '@carbon/react';
import styles from './geologic-interval.module.scss';
import classNames from 'classnames';
import { format } from 'date-fns';

interface GeologicIntervalProps {
  name: string;
  gridSurface?: {
    name: string;
    owner: string;
    createdAt: string;
    source: string;
  };
  selected: boolean;
  onClick: () => void;
  onClose: () => void;
}

export const GeologicInterval = ({
  name,
  gridSurface,
  selected,
  onClick,
  onClose,
}: GeologicIntervalProps) => {
  return (
    <section
      className={classNames(styles.container, {
        [styles.selected]: selected,
      })}
      onClick={onClick}
    >
      <h5 className={styles.name}>{name}</h5>
      <div className={styles.gridSurface}>
        <span>Grid Surface:</span>
        {gridSurface ? (
          <Tag type="blue" size="sm" filter onClose={onClose}>
            {gridSurface.name}
          </Tag>
        ) : (
          <Tag>--</Tag>
        )}
      </div>
      {gridSurface && (
        <span>
          Owner:{' '}
          {`${gridSurface?.owner} | Created: ${format(
            new Date(gridSurface?.createdAt),
            'MM/dd/yyyy'
          )} | Source: ${gridSurface?.source}`}
        </span>
      )}
    </section>
  );
};
